/* global Cookies, attachEvent, activateGtmScripts */

const advanceCookieElement = document.querySelector('.advance-cookie-banner-wrapper');
// eslint-disable-next-line no-unused-vars
const allowedCookies = [];
if (advanceCookieElement) {
  const cookieItems = document.querySelectorAll('.advance-cookie-modal__details-item input');
  const essentialCookie = document.querySelectorAll('.is-necessary input');
  const cookieFooter = document.querySelector('.footer__nav--right .btn--cookie-setting');

  if (!Cookies.get('necessary_cookie')) {
    advanceCookieElement.classList.add('cookie-not-set');
    if (cookieFooter) {
      cookieFooter.classList.add('cookie-not-set');
    }
  }

  const activeScripts = () => {
    activateGtmScripts();
    try {
      const cookieValue = Cookies.get('performance_cookie');
      if (cookieValue && cookieValue === 'true') {
        advanceCookieElement.querySelectorAll('.advance-cookie-banner__modal-content input').forEach((item) => {
          // eslint-disable-next-line no-param-reassign
          if (item.dataset.cookie === 'performance_cookie') {
            item.checked = item.dataset.cookie;
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  // Reload page
  const reloadPage = () => {
    setTimeout(() => {
      window.location.reload();
    }, 50);
  };

  const setCookie = (cookieName) => {
    Cookies.set(cookieName, true, { expires: 365 });
  };

  const toggleCookieInput = (elem, toggle) => {
    // eslint-disable-next-line no-param-reassign
    elem.checked = toggle;
  };

  // *******************************************************************************
  // Set cookie on save button
  // *******************************************************************************
  attachEvent('.btn--cookie-confirm-all', 'click', (ev) => {
    cookieItems.forEach((item) => {
      const cookieName = item.getAttribute('id');
      setCookie(cookieName);
      toggleCookieInput(item, true);
    });
    // reloadPage();
    activeScripts();
    ev.preventDefault();
  });

  attachEvent(
    '.btn--cookie,.btn--cookie-confirm-selected,.advance-cookie-modal__close-btn,.advance-cookie-banner__close-btn',
    'click',
    (ev) => {
      cookieItems.forEach((item) => {
        const cookieName = item.getAttribute('id');
        if (item.checked) {
          setCookie(cookieName);
        } else {
          toggleCookieInput(item, false);
          Cookies.remove(cookieName);
        }
      });
      reloadPage();
      ev.preventDefault();
    },
  );

  // *******************************************************************************
  // Open Modal
  // *******************************************************************************
  attachEvent('.advance-cookie-modal-toggle-btn, .btn--cookie-setting:not(.cookie-not-set)', 'click', (ev) => {
    ev.preventDefault();
    const cookieParentModalElem = document.querySelector('.advance-cookie-banner-wrapper');
    cookieParentModalElem.querySelector('.advance-cookie-modal').classList.add('is-open-modal');
    toggleBodyScrollLock(true);
  });

  // *******************************************************************************
  // Close Modal
  // *******************************************************************************
  attachEvent('.advance-cookie-modal__close-btn', 'click', (ev) => {
    ev.target.closest('.advance-cookie-modal').classList.remove('is-open-modal');
    toggleBodyScrollLock(false);
    ev.preventDefault();
  });

  attachEvent('.close-cookie-modal', 'click', (ev) => {
    ev.target.closest('.advance-cookie-modal').classList.remove('is-open-modal');
    toggleBodyScrollLock(false);
    ev.preventDefault();
  });

  // *******************************************************************************
  // Check already set cookie on load
  // *******************************************************************************
  cookieItems.forEach((item) => {
    const cookieName = item.getAttribute('id');
    const cookieStatus = Cookies.get(cookieName);

    // eslint-disable-next-line no-param-reassign
    toggleCookieInput(item, !!cookieStatus);
  });

  essentialCookie.forEach((input) => {
    toggleCookieInput(input, true);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const modalEle = document.querySelector('.advance-cookie-modal');

      if (modalEle.classList.contains('is-open-modal')) {
        modalEle.classList.remove('is-open-modal');
        toggleBodyScrollLock(false);
      }
    }
  });
}
